import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

// const ProtectedRoute = ({ children }) => {
//     const { instance } = useMsal();
//     const activeAccount = instance.getActiveAccount();

//     if (!activeAccount) {
//         return <Navigate to="/login" />;
//     }

//     // Check if the user has the required role
//     if (!activeAccount.idTokenClaims["extension_Role_Godmode"]) {
//         return <Navigate to="/unauthorized" />;
//     }

//     return children ? children : <Outlet />;
// };

const ProtectedRoute = ({ children }: { children: React.JSX.Element }) => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress, instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const location = useLocation(); 

    if (inProgress !== 'none') {
        // MSAL is processing, show nothing or a spinner
        return null;
    }

    if (!isAuthenticated) {
        sessionStorage.setItem('postLoginRedirect', location.pathname + location.search);
        return <Navigate to="/login" replace />;
    }

    // Check if the user has the required role
    if (!activeAccount ||
        !activeAccount.idTokenClaims ||
        !activeAccount.idTokenClaims["extension_Role_Godmode"]
    ) {
        return <Navigate to="/unauthorized" />;
    }

    return children ? children : <Outlet />;
};

export default ProtectedRoute;
